import { createRouter, createWebHistory } from "vue-router";
import { historyRoutes } from "./history.js";
import { coinholdRoutes } from "./coinhold.js";
import { stakingRoutes } from "./staking.js";
import { profileRoutes } from "./profile.js";
import { topUpRoutes } from "./topup.js";
import { exchangeRoutes } from "./exchange.js";
import { withdrawRoutes } from "./withdraw.js";
import { giftCardsRoutes } from "./giftCards.js";

import { p2pRoutes } from "./p2p.js";
import { cardRoutes } from "./card.js";

let isPopState = false;

export const MAIN_PAGES_OF_EACH_TAB = [
  "/dashboard",
  "/p2p",
  "/apps",
  "/coinhold",
  "/profile/base",
];

const routes = [
  {
    path: "/",
    name: "Loading",
    component: () => import("@/views/Loading.vue"),
    meta: { showDemoVersion: true },
  },
  {
    path: "/dashboard",
    name: "Dashboard",
    component: () => import("@/views/Dashboard.vue"),
    meta: { topLevel: true, menu: true, showDemoVersion: true },
  },
  {
    path: "/dashboard-onboarding",
    name: "DashboardOnboarding",
    component: () => import("@/views/DashboardOnboarding.vue"),
    meta: { topLevel: false, menu: false, showDemoVersion: false },
  },

  ...historyRoutes,
  ...coinholdRoutes,
  ...stakingRoutes,
  ...profileRoutes,
  ...topUpRoutes,
  ...exchangeRoutes,
  ...withdrawRoutes,
  {
    path: "/more",
    name: "More",
    component: () => import("@/views/More.vue"),
  },
  {
    path: "/coin/:name",
    name: "Coin",
    component: () => import("@/views/Coin.vue"),
  },
  {
    path: "/referral",
    name: "Referral",
    component: () => import("@/views/Referral/Referral.vue"),
  },
  {
    path: "/apps",
    name: "Apps",
    component: () => import("@/views/Apps.vue"),
    meta: { topLevel: true, menu: true, showDemoVersion: true },
  },
  {
    path: "/blog/:alias",
    name: "Blog",
    component: () => import("@/views/Blog/Blog.vue"),
  },

  {
    path: "/info",
    name: "Info",
    component: () => import("@/views/Shared/Info.vue"),
  },
  {
    path: "/rewards",
    name: "Rewards",
    component: () => import("@/views/RewardsCentre/RewardsCentre.vue"),
  },
  {
    path: "/advent-calendar",
    name: "AdventCalendar",
    component: () => import("@/views/AdventCalendar/AdventCalendar.vue"),
  },
  {
    path: "/2fa",
    name: "2FA",
    component: () => import("@/views/Shared/2FA.vue"),
    meta: { public: true },
  },

  {
    path: "/error",
    name: "Error",
    component: () => import("@/views/Error.vue"),
    meta: { public: true, topLevel: true },
  },
  ...cardRoutes,
  ...p2pRoutes,
  ...giftCardsRoutes,
];

const router = createRouter({
  history: createWebHistory(
    // eslint-disable-next-line no-undef
    globalThis?.import_meta_env?.BASE_URL || import.meta.env.BASE_URL,
  ),
  scrollBehavior(to, from, savedPosition) {
    if (from.meta.topLevel) return { top: 0 };
    if (isPopState) {
      isPopState = false;
      return savedPosition;
    }
    return { top: 0 };
  },
  routes,
});

router.options.history.listen((to, from, info) => {
  if (info.direction === "back") isPopState = true;
});

export default router;
